import React, { useEffect, useState  } from 'react';
import { SellerNav } from './DealerNav';
import { useNavigate } from 'react-router-dom';
import { Navigate, useParams } from 'react-router-dom'; // import useParams
import api from '../api';
export const SimpleCarDetails = () => {
   const { Vehicle_Id } = useParams(); 
   const navigate = useNavigate();
   const [vehicleData, setVehicleData] = useState(null);
   const [sellerid, setSeller] = useState('');
   const [vechicleid, setVehicleId] = useState('');
   const [vechiclevideo, setVechicleVideo] = useState('');
   console.log(vechiclevideo)
   const [location, setLocation] = useState('');
   const [vin, setVin] = useState('');
   const [year, setYear] = useState('');
   const [make, setMake] = useState('');
   const [model, setModel] = useState('');
   const [trim, setTrim] = useState('');
   const [mileage, setMileage] = useState('');
   const [color, setColor] = useState('');
   const [keys, setkeys] = useState('');
   const [settire, setSetTire] = useState('');
   const [windowtint, setWindowTint] = useState('');
   const [aftermarketexhaust, setAftermarketExhaust] = useState('');
   const [aftermarkrims, setAftermarkRims] = useState('');
   const [roofrack, setRoofRack] = useState('');
   const [remotestarter, setRemoteStarter] = useState('');
   const [aftermarkstereo, setAftermarkStereo] = useState('');
   const [aftermarketspoiler, setAftermarketSpoiler] = useState('');
   const [minordamage, setMinorDamage] = useState('');
   const [interiorimage, setInteriorImage] = useState('');
   const [interiorimagetwo, setInteriorImageTwo] = useState('');
   const [interiorimagethree, setInteriorImageThree] = useState('');
   const [interiorimagefour, setInteriorImageFour] = useState('');
   const [exteriorimage, setExteriorImage] = useState('');
   const [exteriorimagetwo, setExteriorImageTwo] = useState('');
   const [exteriorimagethree, setExteriorImageThree] = useState('');
   const [exteriorimagefour, setExteriorImageFour] = useState('');
   const [dashboardimage, setDashboardImage] = useState('');
   const [dashboardimagetwo, setDashboardImageTwo] = useState('');
   const [dashboardimagethree, setDashboardImageThree] = useState('');
   const [dashboardimagefour, setDashboardImageFour] = useState('');
   const [rimsimage, setRimsImage] = useState('');
   const [rimsimagetwo, setRimsImageTwo] = useState('');
   const [rimsimagethree, setRimsImageThree] = useState('');
   const [rimsimagefour, setRimsImageFour] = useState('');
   const [fadingpaints, setFadingPaints] = useState('');
   const [rust, setRust] = useState('');
   const [haildamage, setHailDamage] = useState('');
   const [extmintcondition, setExtMintCondition] = useState('');
   const [dents, setDents] = useState('');
   const [ripsOrTears, setRipsOrTears] = useState(false); 
   const [OtherDamageDescription, setotherdamage] = useState(false); 
   const [Intdamge, setotherIntdamage] = useState(false); 
   const [visibleStain, setVisibleStain] = useState(false);
   const [strongSmell, setStrongSmell] = useState(false);
   const [damagedSystems, setDamagedSystems] = useState(false);
   const [IntmintCondition, setIntMintCondition] = useState(false);
   const [smokeInVehicle, setSmokeInVehicle] = useState(false);
   const [hasOriginalRims, setHasOriginalRims] = useState(null);
   const [tireReplacement, setTireReplacement] = useState(null); 
   const [vehicleDrivable, setVehicleDrivable] = useState(null);
   const [crackOnWindshield, setCrackOnWindshield] = useState(null);
   const [extendedWarranty, setExtendedWarranty] = useState(null);
   const [tradeInInterest, setTradeInInterest] = useState(null);
   const [sellTiming, setSellTiming] = useState(''); 
   const [DonotNeedCar, setDonotNeedCar] = useState('');
   const [MechElectIssues, setMechElectIssues] = useState('');
   const [DownSize, setDownSize] = useState(''); 
   const [BuyAnotherCar, setBuyAnotherCar] = useState('')
   const [carCondition, setCarCondition] = useState('');
   const [accidentclaims, setAccidentClaims] = useState('');
   const [howmuchclaims, setHowMuchClaims] = useState('');
   const [carrims, setCarRims] = useState('');
   const [stockrim, setStockRim] = useState('');
   const [issuevichle, setIssueVichle] = useState('');
   const [issuevichledecs, setIssueVichleDecs] = useState('');
   const [carmodify, setCarMdify] = useState('');
   const [carmodifydecs, setCarMdifyDecs] = useState('');
   const [financed, setFinanced] = useState('');
   const [financeddesc, setFinancedDesc] = useState('');
   const [vehicledrivabledesc, setVehicleDrivableDes] = useState('');
   const [biddingstatus, setVechicleBiddingStatus] = useState('');
   const [sellertransmission, setSellerTransmission] = useState('');
   const [vechiclenotes, setVechicleNotes] = useState("");
   const storedUserId = sessionStorage.getItem('user_id');
   const [bidHistory, setBidHistory] = useState([]);
   const [totalBids, setTotalBids] = useState(0);
   const [tranmission, setVechicleTranmission] = useState(0);
   const [agentDetails, setAgentDetails] = useState(null); // Store agent details
   const [isLoading, setIsLoading] = useState(false); // Loading state
   const [ownership, setOwnerShip] = useState('');
   const [drivingl, setDrivingL] = useState('');
   const [selectedFeatures, setSelectedFeatures] = useState([]);
   useEffect(() => {
      const userId = sessionStorage.getItem('user_id');
      if (!storedUserId) {
         navigate('/sellerin');
         return; // Stop further execution
      }      
       fetchData();
       fetchdatereport();
       fetchDateBids();
       fetchAgentData();
   }, []);

   const fetchDateBids = async () => {
      try {
        const response = await api.get(`/bidhistory/${Vehicle_Id}`);
        const sellerBid = response.data;
        setBidHistory(sellerBid.VehicleBids);  // Store bid data in state
        setTotalBids(sellerBid.TotalBids);     // Store total bids in state
        console.log("ddfds",sellerBid.TotalBids)
        console.log("ds",sellerBid.VehicleBids)
      } catch (error) {
        console.error("Error fetching bid history:", error);
      }
    };

   const fetchdatereport = async () => {
      try {
          const response = await api.get(
         `/agent/getinspectionreport/${Vehicle_Id}`
      );
         const datareport = response.data;
         setSellerTransmission(datareport.vehicleInspectionReport.Transmission_Type);
      } catch (error) {
          console.error("Error fetching inspection report:", error);
      }
   };
   // This is Funtion Add Comma After Slected Value 
      const features = [
         settire,
         windowtint,
         aftermarketexhaust,
         roofrack,
         remotestarter,
         aftermarkstereo,
         aftermarketspoiler,
      ];
         const filteredFeatures = features.filter(feature => feature);
         const featuresString = filteredFeatures.join(',');
         const featurestwo = [
         minordamage,
         fadingpaints,
         rust,
         haildamage,
         extmintcondition,
         dents,
         OtherDamageDescription,
      ];
         const filteredFeaturestwo = featurestwo.filter(feature => feature);
         const featuresStringtwo = filteredFeaturestwo.join(',');
         const featuresthree = [
         ripsOrTears,
         visibleStain,
         strongSmell,
         damagedSystems,
         IntmintCondition,
         Intdamge,

      ];
      const filteredFeaturesthree = featuresthree.filter(feature => feature);
      const featuresStringthree = filteredFeaturesthree.join(',');

      useEffect(() => {
         if (Vehicle_Id && (interiorimage || interiorimagetwo || interiorimagethree || interiorimagefour ||  exteriorimage || dashboardimage || dashboardimagetwo || dashboardimagethree || dashboardimagefour || rimsimage || rimsimagetwo || rimsimagethree || rimsimagefour)) {
             initializeFlexSlider();
         }
      }, [Vehicle_Id, interiorimage, interiorimagetwo, interiorimagethree, interiorimagefour, exteriorimage, dashboardimage, rimsimage]);

      const fetchData = async () => {
      try {
         const response = await api.get(`/seller/vehicle/${Vehicle_Id}`);
         const vehicleData = response.data;
         console.log(vehicleData)
         setSeller(vehicleData.vehicle.Seller_Id)
         setLocation(vehicleData.vehicle.Location || '');
         setVin(vehicleData.vehicle.VIN || '');
         setYear(vehicleData.vehicle.Year || '');
         setMake(vehicleData.vehicle.Make || '');
         setModel(vehicleData.vehicle.Model || '');
         setTrim(vehicleData.vehicle.Trim || '');
         setMileage(vehicleData.vehicle.Mileage || '');
         setColor(vehicleData.vehicle.Color || '');
         setkeys(vehicleData.vehicle.Car_Keys || '');
         setSetTire(vehicleData.vehicle['2_Sets_Of_Tire'] || ''); 
         setotherdamage(vehicleData.vehicle['Other_Damage_Description'] || ''); 
         setotherIntdamage(vehicleData.vehicle['Other_Interior_Damage_Description'] || ''); 
         setWindowTint(vehicleData.vehicle['Win_Tint'] || ''); 
         setAftermarketExhaust(vehicleData.vehicle['Aftermark_Exhaust'] || ''); 
         setAftermarkRims(vehicleData.vehicle['Aftermark_Rims'] || ''); 
         setRoofRack(vehicleData.vehicle['Roof_Rack'] || ''); 
         setRemoteStarter(vehicleData.vehicle['Remote_Start'] || '');
         setRemoteStarter(vehicleData.vehicle['Remote_Start'] || '');
         setAftermarkStereo(vehicleData.vehicle['Aftermark_Stereo'] || '');
         setAftermarketSpoiler(vehicleData.vehicle['Aftermark_Spoiler'] || '');
         setMinorDamage(vehicleData.vehicle['Minor_Damage'] || '');
         setInteriorImage(vehicleData.vehicle['Interior_Image'] || '');
         setInteriorImageTwo(vehicleData.vehicle['Interior_Image2'] || '');
         setInteriorImageThree(vehicleData.vehicle['Interior_Image3'] || '');
         setInteriorImageFour(vehicleData.vehicle['Interior_Image4'] || '');
         setExteriorImage(vehicleData.vehicle['Exterior_Image'] || '');
         setExteriorImageTwo(vehicleData.vehicle['Exterior_Image2'] || '');
         setExteriorImageThree(vehicleData.vehicle['Exterior_Image3'] || '');
         setExteriorImageFour(vehicleData.vehicle['Exterior_Image4'] || '');
         setDashboardImage(vehicleData.vehicle['Dashboard_Image'] || '');
         setDashboardImageTwo(vehicleData.vehicle['Dashboard_Image2'] || '');
         setDashboardImageThree(vehicleData.vehicle['Dashboard_Image3'] || '');
         setDashboardImageFour(vehicleData.vehicle['Dashboard_Image4'] || '');
         setRimsImage(vehicleData.vehicle['Rims_Image'] || '');
         setRimsImageTwo(vehicleData.vehicle['Rims_Image2'] || '');
         setRimsImageThree(vehicleData.vehicle['Rims_Image3'] || '');
         setRimsImageFour(vehicleData.vehicle['Rims_Image4'] || '');
         setFadingPaints(vehicleData.vehicle['Fading_Paints'] || '');
         setRust(vehicleData.vehicle['Rust'] || '')
         setHailDamage(vehicleData.vehicle['Hail_Damage'] || '')
         setExtMintCondition(vehicleData.vehicle['Ext_Mint_Condition'] || '')
         setDents(vehicleData.vehicle['Dents'] || '')
         setRipsOrTears(vehicleData.vehicle['Seats_Rips_Tears'] || '')
         setVisibleStain(vehicleData.vehicle['Seats_Visible_Stain'] || '')
         setStrongSmell(vehicleData.vehicle['Strong_Smell'] || '')
         setDamagedSystems(vehicleData.vehicle['Nav_Entmt_Ctrl_Dmg_Sys'] || '')
         setIntMintCondition(vehicleData.vehicle['Int_Mint_Condition'] || '')
         setSmokeInVehicle(vehicleData.vehicle['Smoke_In_Vehicle'] || 'No')
         setHasOriginalRims(vehicleData.vehicle['Original_Factory_Rims'] || 'No')
         setTireReplacement(vehicleData.vehicle['Tires_Repld_12_Months'] || 'No')
         setVehicleDrivable(vehicleData.vehicle['Vehicle_Drivable'] || 'No')
         setCrackOnWindshield(vehicleData.vehicle['Windshield_Crack'] || 'No')
         setExtendedWarranty(vehicleData.vehicle['Extended_Warranty'] || 'No')
         setTradeInInterest(vehicleData.vehicle['TradeIn_Interested'] || 'No')
         setVehicleDrivableDes(vehicleData.vehicle['vehicle_drivable_not_explanation'])
         setSellTiming(vehicleData.vehicle['How_Soon_Ready_Sell'])
         setDonotNeedCar(vehicleData.vehicle['Donot_Need_Car'] || "")
         setMechElectIssues(vehicleData.vehicle['Mech_Elect_Issues'] || "")
         setDownSize(vehicleData.vehicle['Downsize'] || "")
         setBuyAnotherCar(vehicleData.vehicle['Buy_Another_Car'] || "")
         setCarCondition(vehicleData.vehicle['Car_Condition'])
         setAccidentClaims(vehicleData.vehicle['Accident_Claims'] || "No")
         setHowMuchClaims(vehicleData.vehicle['How_Much_Claims'] || "")
         setCarRims(vehicleData.vehicle['Car_Rims'])
         setStockRim(vehicleData.vehicle['Stock_Rims'] || "No")
         setIssueVichle(vehicleData.vehicle['Any_Vehicle_Issues'] || "No")
         setIssueVichleDecs(vehicleData.vehicle['Vehicle_Issues_desc'] || "")
         setCarMdify(vehicleData.vehicle['Car_Modification'] || "No")
         setCarMdifyDecs(vehicleData.vehicle['Modification_desc'] || "")
         setFinanced(vehicleData.vehicle['Leased_Financed'] || "No")
         setFinancedDesc(vehicleData.vehicle['Financed_By'] || "") 
         setVehicleId(vehicleData.vehicle['Vehicle_Id'] ) 
         setVechicleVideo(vehicleData.vehicle['Vehicle_video'] ) 
         setVechicleBiddingStatus(vehicleData.vehicle['Bidding_Status'] ) 
         setVechicleNotes(vehicleData.vehicle["Car_Notes"]);
         setVechicleTranmission(vehicleData.vehicle["Transmission_Type"]);
         setOwnerShip(vehicleData.vehicle.Ownership_Doc);
         setDrivingL(vehicleData.vehicle.Driving_Licence_Doc);
         setSelectedFeatures(vehicleData.vehicle.Additional_Car_Feature);
         if (vehicleData.vehicle['Leased_Financed'] === 1) {
            setFinanced('Yes');
         } 
         if (vehicleData.vehicle['Car_Modification'] === 1) {
            setCarMdify('Yes');
         } 
         if (vehicleData.vehicle['Any_Vehicle_Issues'] === 1) {
         setIssueVichle('Yes');
         } 
         if (vehicleData.vehicle['Stock_Rims'] === 1) {
         setStockRim('Yes');
         } 
         if (vehicleData.vehicle['Accident_Claims'] === 1) {
         setAccidentClaims('Yes');
         }
         if (vehicleData.vehicle['Donot_Need_Car'] === 1) {
         setDonotNeedCar('Don’t Need The Car Anymore');
         }
         if (vehicleData.vehicle['Mech_Elect_Issues'] === 1) {
         setMechElectIssues('Selling Because The Car Has Some Mechanical/ Electrical Issues');
         }
         if (vehicleData.vehicle['Downsize'] === 1) {
         setDownSize('Selling To Downsize');
         }
         if (vehicleData.vehicle['Buy_Another_Car'] === 1) {
         setBuyAnotherCar('Selling To Buy Another Car');
         }
         if (vehicleData.vehicle['TradeIn_Interested'] === 1) {
         setTradeInInterest('Yes');
         }
         if (vehicleData.vehicle['Extended_Warranty'] === 1) {
         setExtendedWarranty('Yes');
         }
         if (vehicleData.vehicle['Windshield_Crack'] === 1) {
         setCrackOnWindshield('Yes');
         }
         if (vehicleData.vehicle['Vehicle_Drivable'] === 1) {
         setVehicleDrivable('Yes');
         }
         if (vehicleData.vehicle['Tires_Repld_12_Months'] === 1) {
         setTireReplacement('Yes');
         }
         if (vehicleData.vehicle['Original_Factory_Rims'] === 1) {
         setHasOriginalRims('Yes');
         }
         if (vehicleData.vehicle['Original_Factory_Rims'] === 1) {
         setHasOriginalRims('Yes');
         }
         if (vehicleData.vehicle['Smoke_In_Vehicle'] === 1) {
         setSmokeInVehicle('Yes');
         }
         if (vehicleData.vehicle['2_Sets_Of_Tire'] === 1) {
         setSetTire('2 Sets of Tire');
         }
         if (vehicleData.vehicle['Win_Tint'] === 1) {
         setWindowTint('Window Tint');
         }
         if (vehicleData.vehicle['Aftermark_Exhaust'] === 1) {
         setAftermarketExhaust('Aftermarket Exhaust');
         } 
         if (vehicleData.vehicle['Aftermark_Rims'] === 1) {
         setAftermarkRims('Aftermarket Rims');
         }
         if (vehicleData.vehicle['Roof_Rack'] === 1) {
         setRoofRack('Roof Rack');
         }
         if (vehicleData.vehicle['Remote_Start'] === 1) {
         setRemoteStarter('Remote Start');
         }
         if (vehicleData.vehicle['Aftermark_Stereo'] === 1) {
         setAftermarkStereo('Aftermarket Stereo');
         }
         if (vehicleData.vehicle['Aftermark_Spoiler'] === 1) {
         setAftermarketSpoiler('Aftermarket Spoiler');
         }
         if (vehicleData.vehicle['Minor_Damage'] === 1) {
             setMinorDamage('Minor Damage');
         }else{
            setMinorDamage('');
         }
         if (vehicleData.vehicle['Fading_Paints'] === 1) {
            setFadingPaints('Fading Paints');
         }else{
            setFadingPaints('');
         }
         if (vehicleData.vehicle['Rust'] === 1) {
             setRust('Rust');
         }else {
            setRust('');
         }
         if (vehicleData.vehicle['Hail_Damage'] === 1) {
             setHailDamage('Hail Damage');
         }
         if (vehicleData.vehicle['Ext_Mint_Condition'] === 1) {
             setExtMintCondition('Mint Condition');
         }
         if (vehicleData.vehicle['Dents'] === 1) {
             setDents('Dents');
         }
         if (vehicleData.vehicle['Int_Mint_Condition'] === 1) {
             setIntMintCondition('Mint Condition');
         }
         if (vehicleData.vehicle['Nav_Entmt_Ctrl_Dmg_Sys'] === 1) {
            setDamagedSystems('Damaged Systems');
         }
         if (vehicleData.vehicle['Strong_Smell'] === 1) {
            setStrongSmell('Strong Smell');
         }
         if (vehicleData.vehicle['Seats_Visible_Stain'] === 1) {
            setVisibleStain('Visible Stain On The Seats');
         }
         if (vehicleData.vehicle['Seats_Rips_Tears'] === 1) {
            setRipsOrTears('Rips Or Tears On The Seats');
         }
         } catch (error) {
             console.error('Error fetching vehicle details:', error);
         }
      };

   const initializeFlexSlider = () => {
      window.$('.flexslider').flexslider({
         animation: "slide",
         controlNav: "thumbnails",
         start: function(slider) {
            window.$('body').removeClass('loading');
         }
      });
   };

   const handleClick = () => {
      // Extract the vehicle ID from the URL
      sessionStorage.setItem('isNewUser', 'true');
      const url = window.location.href;
      const urlParts = url.split('/');
      const vehicleId = urlParts[urlParts.length - 1]; // Assuming vehicle ID is the last part of the URL
      // Store the vehicle ID in session storage
      sessionStorage.setItem('Vehicle_Id', vehicleId);
      const sessionValue = sessionStorage.getItem('Vehicle_Id');
   };
   const fetchAgentData = async () => {
      setIsLoading(true); // Start loading
      try {
        const response = await api.get(`/agent/agentdetails/${Vehicle_Id}`);
        console.log(response.data); // Log the response to check the data
        setAgentDetails(response.data[0]); // Set the first agent object
      } catch (error) {
        console.error("Error fetching agent details:", error);
      } finally {
        setIsLoading(false); // Stop loading
      }
    };
return (
<section class="car-details my-carnew">
   <SellerNav />
   <div class="container">
      <div class="info-message text-center">
         <i class="fa-regular fa-circle-xmark mb-3"></i>
         <h2>Car is no longer available to bid.</h2>
      </div>
</div>
</section>
);
};